export function isCashSessionAlreadyOpenError(error: string | undefined): boolean {
  const msg = error ?? '';
  return msg.includes('cash_session_already_open') || /caja abierta/i.test(msg);
}

export function isCashSessionNotOpenError(error: string | undefined): boolean {
  const msg = error ?? '';
  return /cash_session_not_open/i.test(msg);
}

export function isSaleCashSessionFkError(error: string | undefined): boolean {
  const msg = (error ?? '').toLowerCase();
  return msg.includes('sales_cash_session_id_fkey') || msg.includes('cash_session_id_fkey');
}
